import { Link } from 'react-router-dom';
import type { ShipmentLinkedDeal } from './types';
import { ploomesDealPath } from '@v2/features/ploomes-deals/dealPath';

type Props = {
    deals: ShipmentLinkedDeal[];
    count: number;
};

export default function ShipmentDealsCell({ deals, count }: Props) {
    if (count === 0) {
        return <span className="text-gray-400">—</span>;
    }

    const visible = deals.slice(0, 4);
    const extra = count - visible.length;

    return (
        <div className="min-w-[140px]">
            <p className="mb-1 text-[11px] font-semibold text-gray-500">
                {count} pedido{count !== 1 ? 's' : ''}
            </p>
            <div className="flex flex-wrap gap-1">
                {visible.map((deal) => (
                    <Link
                        key={deal.id}
                        to={ploomesDealPath(deal)}
                        onClick={(e) => e.stopPropagation()}
                        className={`inline-flex max-w-[8rem] truncate rounded-md border px-1.5 py-0.5 text-[11px] font-semibold hover:shadow-sm ${
                            deal.is_primary
                                ? 'border-primary/40 bg-primary/10 text-primary'
                                : 'border-gray-200 bg-gray-50 text-gray-700 hover:bg-gray-100'
                        }`}
                        title={deal.label}
                    >
                        {deal.label}
                    </Link>
                ))}
                {extra > 0 ? (
                    <span className="inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-[11px] text-gray-600">
                        +{extra}
                    </span>
                ) : null}
            </div>
        </div>
    );
}
